<template>
  <v-autocomplete v-bind="$attrs"
                  :items="domains"
                  dense
                  :name="name"
                  v-model="selected_domain"
                  :prepend-inner-icon="''"
                  :error-messages="errorMessages"
                  :loading="loading">
    <template v-if="!noLabel" slot="label">{{ label }}</template>
    <template v-if="hasPrependIcon" v-slot:prepend-inner>
      <v-icon small>{{ $attrs['prepend-inner-icon'] }}</v-icon>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DOMAIN_TYPES } from '@/consts/domains'

export default {
  name: 'DomainSelect',
  model: {
    event: 'input',
    prop: 'remote_domain'
  },
  $_veeValidate: {
    // value getter
    value () {
      return this.selected_domain
    },
    // name getter
    name () {
      return this.name
    }
  },
  props: {
    noLabel: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: 'Select domain'
    },
    remote_domain: {
      type: String,
      default: ''
    },
    allDomains: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'Domain'
    },
    errorMessages: Array,
  },
  data: () => ({
    selected_domain: '',
    domains: [],
    domainsMeta: [],
    loading: true
  }),
  methods: {
    ...mapActions({
      getDomains: 'email/getDomains',
      reportSuccess: 'reportSuccess',
      reportError: 'reportError',
    }),
    async getData () {
      try {
        await this.getDomains(this.$route.query.user)
        this.parseData()
        this.loading = false
      } catch (e) {
        console.warn(e)
        this.reportError(e)
      }
    },

    parseData () {
      if (this.$route.query.user && this.hosting.type === 'whm') {
        // handle reseller subaccount management
        const domain = this.hosting_detail?.accountsummary?.domain || this.hosting_detail.accounts.find((acc) => {
          return acc.user === this.$route.query.user
        }).domain
        this.domains.push(domain)
        return
      }

      this.domains_list.forEach(item => {
        for (let key in item) {
          if (item.hasOwnProperty(key)) {
            switch (key) {
              case 'main_domain':
                this.domains.push(item[key])
                this.domainsMeta.push({ domain: item[key], type: DOMAIN_TYPES.MAIN })
                break
              case 'sub_domains':
                if (item[key].length) {
                  item[key].forEach(item => {
                    this.domains.push(item)
                    this.domainsMeta.push({ domain: item, type: DOMAIN_TYPES.SUB })
                  })
                }
                break
              case 'addon_domains':
                if (item[key].length) {
                  item[key].forEach(item => {
                    this.domains.push(item)
                    this.domainsMeta.push({ domain: item, type: DOMAIN_TYPES.ADDON })
                  })
                }
                break
            }
          }
        }
      })
    },

    setDomain () {
      if (this.remote_domain === '') {
        this.selected_domain = this.domains[0]
      } else if (this.domains.includes(this.remote_domain)) {
        this.selected_domain = this.remote_domain
      } else {
        this.selected_domain = this.domains[0]
      }
    },

    created () {
      this.$emit('created', this.selected_domain)
    },
  },
  computed: {
    ...mapGetters({
      domains_list: 'email/domains_list',
      hosting_detail: 'hosting_detail',
      hosting: 'hosting',
    }),
    hasPrependIcon () {
      return !!this.$attrs['prepend-inner-icon']
    },
  },
  watch: {
    selected_domain (val) {
      this.$emit('input', val)
      const domain = this.domainsMeta.find(domain => domain.domain === val)
      this.$emit('domain-type-selected', domain?.type)
    },
    remote_domain () {
      this.setDomain()
    },
  },
  async created () {
    if (this.allDomains) {
      this.domains.push('ALL')
    }
    await this.getData()
    this.setDomain()
  }
}
</script>
